/**
 * NumbersPanel.js
 * - handler for the numbers panel
 * @since March 26, 2019
 * @author
 * - Aron Joshua Bagtas <aaron@qstrike.com>
 *
 * Requirements:
 * - jQuery
 * - Mustache
 *
 * Usage:
 *  handle the setup of numbers panel
 */

function NumbersPanel(element) {
    this.panel = document.getElementById(element);

    this.locations = [];
    this.fontAccents = [];
    this.fontColors = [];
}

NumbersPanel.fontExcept = [
    // "Uni Script BSB",
    // "Plain BSB",
];

NumbersPanel.prototype = {
    constructor: NumbersPanel,

    getPanel: function() {
        var rendered = Mustache.render(this.panel.innerHTML);
        return rendered;
    },

    setLocations: function() {
        var applications = ub.current_material.settings.applications;
        var temp_app;

        this.locations = [];

        temp_app = _.find(applications, {application_type: NumbersPanel.LOCATION_FRONT.type});
        this.locations.push({
            text: NumbersPanel.LOCATION_FRONT.text,
            enabled: temp_app !== undefined,
            code: temp_app !== undefined ? temp_app.code : "",
            perspective: NumbersPanel.LOCATION_FRONT.perspective,
            part: NumbersPanel.LOCATION_FRONT.part
        });

        temp_app = _.find(applications, {application_type: NumbersPanel.LOCATION_BACK.type});
        this.locations.push({
            text: NumbersPanel.LOCATION_BACK.text,
            enabled: temp_app !== undefined,
            code: temp_app !== undefined ? temp_app.code : "",
            perspective: NumbersPanel.LOCATION_BACK.perspective,
            part: NumbersPanel.LOCATION_BACK.part
        });

        if (!ub.funcs.is_sleeveless()) {
            temp_app = _.find(applications, function(app) {
                            return app.application_type === NumbersPanel.LOCATION_LEFT_SLEEVE.type && app.application.layer === NumbersPanel.LOCATION_LEFT_SLEEVE.layer;
                        });
            this.locations.push({
                text: NumbersPanel.LOCATION_LEFT_SLEEVE.text,
                enabled: temp_app !== undefined,
                code: temp_app !== undefined ? temp_app.code : "",
                perspective: NumbersPanel.LOCATION_LEFT_SLEEVE.perspective,
                part: NumbersPanel.LOCATION_LEFT_SLEEVE.part
            });

            temp_app = _.find(applications, function(app) {
                            return app.application_type === NumbersPanel.LOCATION_RIGHT_SLEEVE.type && app.application.layer === NumbersPanel.LOCATION_RIGHT_SLEEVE.layer;
                        });
            this.locations.push({
                text: NumbersPanel.LOCATION_RIGHT_SLEEVE.text,
                enabled: temp_app !== undefined,
                code: temp_app !== undefined ? temp_app.code : "",
                perspective: NumbersPanel.LOCATION_RIGHT_SLEEVE.perspective,
                part: NumbersPanel.LOCATION_RIGHT_SLEEVE.part
            });
        }
    },

    setFontAccents: function(app_code) {
        var application = _.find(ub.current_material.settings.applications, {code: app_code});

        if (application !== undefined) {
            this.fontAccents = _.map(ub.data.accents.items, function(i) {
                return {
                    app_code: application.code,
                    accent_id: i.id,
                    image: "/images/sidebar/" + i.thumbnail,
                    active: application.accent_obj.id === i.id ? "uk-active" : "",
                    title: i.code.replace(/_/g, " ")
                };
            });

            // set font colors
            this.setFontColors(application);
        } else {
            ub.utilities.info("Error: Invalid application code");
        }
    },

    setFontColors: function(application) {
        this.fontColors = [];
        var _this = this;

        if (application.application_type === NumbersPanel.MASCOT_TYPE) {
            if (typeof application.mascot !== "undefined") {
                if (application.mascot.id != MASCOT_TYPE_ID) {
                    _.each(application.mascot.layers_properties, function(layer) {
                        var hex_code = layer.default_color;
                        var color = ub.funcs.getColorByColorCode(hex_code);

                        if (typeof color !== "undefined") {
                            // _this.fontColors.push(color);
                        } else {
                            util.error('Hex Code: ' + hexCode + ' not found!');
                        }
                    });
                }
            }
        } else {
            var teamColors = _.sortBy(ub.data.secondaryColorPalette, "order");

            var layers = _.filter(application.accent_obj.layers, function(layer) {
                return !_.contains(NumbersPanel.LAYERS_TO_BE_IGNORE, layer.name);
            });

            var hex_code;
            var color;
            var layer_exist;

            _.each(layers, function(layer) {
                _.each(teamColors, function(team_color) {
                    color = application.color_array[layer.layer_no - 1];

                    if (typeof color === "undefined") {
                        hex_code = layer.default_color;
                        color = ub.funcs.getColorObjByHexCode(hex_code);
                    }

                    searched_layer = _.find(_this.fontColors, {layer_name: layer.name});

                    if (searched_layer === undefined) {
                        _this.fontColors.push({
                            app_code: application.code,
                            layer_name: layer.name,
                            layer_number: layer.layer_no,
                            colors: [{
                                alias: team_color.alias,
                                hex_code: team_color.hex_code,
                                color_code: team_color.color_code,
                                active: color.color_code === team_color.color_code,
                                foreColor: color.forecolor
                            }],
                        });
                    } else {
                        searched_layer.colors.push({
                            alias: team_color.alias,
                            hex_code: team_color.hex_code,
                            color_code: team_color.color_code,
                            active: color.color_code === team_color.color_code,
                            foreColor: color.forecolor
                        });
                    }
                });
            });
        }
    },

    getLocations: function() {
        return this.locations;
    },

    getFontAccents: function() {
        return this.fontAccents;
    },

    getFontColors: function() {
        return this.fontColors;
    }
};

NumbersPanel.MASCOT_TYPE = "mascot";
NumbersPanel.LOGO_TYPE = "logo";
NumbersPanel.MASCOT_TYPE_ID = 1039;

NumbersPanel.LAYERS_TO_BE_IGNORE = ["Mask", "Pseudo Shadow"];

NumbersPanel.LOCATION_FRONT = {
    text: "Front",
    type: "front_number",
    perspective: "front",
    part: "Front Body"
};
NumbersPanel.LOCATION_BACK = {
    text: "Back",
    type: "back_number",
    perspective: "back",
    part: "Back Body"
};
NumbersPanel.LOCATION_LEFT_SLEEVE = {
    text: "L Sleeve",
    type: "sleeve_number",
    layer: "Left Sleeve",
    perspective: "left",
    part: "Sleeve"
};
NumbersPanel.LOCATION_RIGHT_SLEEVE = {
    text: "R Sleeve",
    type: "sleeve_number",
    layer: "Right Sleeve",
    perspective: "right",
    part: "Sleeve"
};

NumbersPanel.SAMPLE_NUMBER = "85";

NumbersPanel.APPLICATION_TYPE = "player_number";

NumbersPanel.PREVIOUS_FONT = "previous";
NumbersPanel.NEXT_FONT = "next";

NumbersPanel.numbersPanel = null;

NumbersPanel.events = {
    is_init: false,

    init: function(numbersPanel) {
        if (!NumbersPanel.events.is_init) {
            NumbersPanel.numbersPanel = numbersPanel;

            $('#primary_options_container').on("keyup", "#richardson-numbers-input-number", NumbersPanel.events.onChangingNumber);
            $('#primary_options_container').on("focusout", "#richardson-numbers-input-number", NumbersPanel.events.onLeaveNumber);
            $("#primary_options_container").on("click", "#richardson-numbers-locations .location-buttons button:not(.btn-enabled)", NumbersPanel.events.onAddLocation);
            $("#primary_options_container").on("click", "#richardson-numbers-locations .location-buttons .remove-location", NumbersPanel.events.onRemoveLocation);
            $("#primary_options_container").on("click", "#richardson-numbers-locations .location-buttons button.btn-enabled", NumbersPanel.events.onChangeLocation);
            $("#primary_options_container").on("click", "#richardson-numbers-font-bar a[data-direction="+NumbersPanel.PREVIOUS_FONT+"]", NumbersPanel.events.onPreviousFont);
            $("#primary_options_container").on("click", "#richardson-numbers-font-bar a[data-direction="+NumbersPanel.NEXT_FONT+"]", NumbersPanel.events.onNextFont);
            $("#primary_options_container").on("click", "#richardson-numbers-font-bar .open-fonts-modal", NumbersPanel.events.onOpenFontsModal);
            $("#primary_options_container").on("click", "#richardson-numbers-font-accents .change-font-accent", NumbersPanel.events.onChangeFontAccent);
            $("#primary_options_container").on("click", "#richardson-numbers-font-colors .font-colors .change-font-color", NumbersPanel.events.onChangeFontColor);

            NumbersPanel.events.is_init = true;
        }

        var hasNumbers = _.filter(ub.current_material.settings.applications, function(app) {
            if (app.application_type === "sleeve_number" || app.application_type === "back_number" || app.application_type === "front_number") {
                return app;
            }
        });

        if (_.size(hasNumbers) > 0) {
            // activate first location
            var activateFirstLocationTime = setInterval(function() {
                if ($('#richardson-numbers-loading').hasClass("uk-hidden")) {
                    $('#richardson-numbers-loading').removeClass("uk-hidden");
                }

                $('#richardson-numbers-locations .location-buttons button.btn-enabled:first').click();
                $('#richardson-numbers-locations .location-buttons button.btn-enabled:first').prop('disabled', true);

                if ($('#richardson-numbers-font-bar').html() !== undefined) {
                    if ($('#richardson-numbers-font-bar').html().trim() !== "") {
                        $('#richardson-numbers-loading').addClass("uk-hidden");
                        clearInterval(activateFirstLocationTime);
                    }
                }
            }, 300);
        } else {
            $('#richardson-numbers-loading').addClass("uk-hidden");
        }
    },

    onChangingNumber: function(e) {
        var ENTER = 13;
        var input = $(this).val().trim();

        if (input.length >= 13) {
            $(this).addClass("uk-form-warning");
            TeamNamePanel.funcs.addInputTextMessage("Maximum of 13 characters");
        } else if (input.length === 0) {
            $(this).addClass("uk-form-warning");
            TeamNamePanel.funcs.addInputTextMessage("This text field is required.");
            return;
        } else {
            $(this).removeClass("uk-form-warning");
            $(".team-name-helper-message").addClass("uk-hidden");
        }

        if (e.keyCode === ENTER) {
            if (input !== "") {
                NumbersPanel.changeNumber(input);

                $(this).removeClass("uk-form-warning");
                $(".team-name-helper-message").addClass("uk-hidden");

                return;
            }
            
            $(".team-name-helper-message").addClass("uk-hidden");
            $(this).removeClass("uk-form-warning");
            NumbersPanel.setNumberToDefault();
        }
    },

    onLeaveNumber: function() {
        var input = $(this).val().trim();

        if (input !== "") {
            NumbersPanel.changeNumber(input);
            return;
        }

        $(".team-name-helper-message").addClass("uk-hidden");
        $(this).removeClass("uk-form-warning");
        NumbersPanel.setNumberToDefault();
    },

    onAddLocation: function() {
        var _this = this;

        // disable location buttons
        $('.richardson-numbers-container .location-buttons button').prop("disabled", true);
        $('.richardson-numbers-container .location-buttons button').removeClass("uk-active");

        var removeBtnEl = $(this).next();
        removeBtnEl.removeClass("invisible");

        var perspective = $(this).data("perspective");
        var part = $(this).data("part");
        var type = NumbersPanel.APPLICATION_TYPE;
        var side;
        var logo_type = type;

        if (_.contains([NumbersPanel.LOCATION_LEFT_SLEEVE.perspective, NumbersPanel.LOCATION_RIGHT_SLEEVE.perspective], perspective)) {
            side = perspective;
        }

        var number_el = $('#richardson-numbers-input-number');
        var number_val = number_el.val();
        var numbersApplication = NumbersPanel.getAllTextApplication();

        console.log(numbersApplication);

        ApplicationCore.funcs.createNewPlayerNumber(perspective, part, side, type, function() {
            var new_code = _.last(Object.keys(ub.current_material.settings.applications));
            var application = _.find(ub.current_material.settings.applications, {code: new_code.toString()});

            if (_.size(numbersApplication) > 0) {
                // Get first number and copy application
                var number = ub.utilities.cloneObject(_.first(numbersApplication));

                // Copy configuration of added application.
                application.colorArrayText = number.colorArrayText;
                application.color_array = number.color_array;
                application.accent_obj = number.accent_obj;
                application.font_obj = number.font_obj;
            }
            
            // Set active
            removeBtnEl.data('app-code', new_code);
            $(_this).data('app-code', new_code);
            $(_this).addClass("btn-enabled");
            $(_this).prop('disabled', false);
            $(_this).click();

            application.text = !_.isEmpty(number_val) ? number_val.toString() : NumbersPanel.SAMPLE_NUMBER;
            number_el.val(application.text);
            ub.funcs.changeFontFromPopup(application.font_obj.id, application);
            NumbersPanel.showHideRemoveButton();
        });
    },

    onRemoveLocation: function() {
        var _this = this;

        UIkit.modal.confirm("Are you sure you want to remove this location?").then(function() {
            var app_code = $(_this).data("app-code").toString();
            var application = _.find(ub.current_material.settings.applications, {code: app_code});

            if (application !== undefined) {
                $(_this).addClass("invisible");
                $(_this).prev().removeClass("uk-active btn-enabled");

                ub.funcs.deleteLocation(application.code, NumbersPanel.showHideRemoveButton);
            } else {
                ub.utilities.info("Error: Application code " + app_code + " is invalid.");
            }
        });
    },

    onChangeLocation: function() {
        var _this = this;

        // disable location buttons
        $('.richardson-numbers-container .location-buttons button').prop("disabled", true);
        $('.richardson-numbers-container .location-buttons button').removeClass("uk-active");

        var app_code = $(this).data("app-code").toString();
        var perspective = $(this).data("perspective");
        var application = _.find(ub.current_material.settings.applications, {code: app_code});

        if (application !== undefined) {
            $('#richardson-numbers-input-number').val(application.text);
        }

        // activate move tool
        ub.funcs.activateMoveTool(app_code);

        var perspectiveController = new PerspectiveController();
        perspectiveController.setPerspective(perspective);

        NumbersPanel.numbersPanel.setFontAccents(app_code);
        NumbersPanel.renderFontsBar(app_code, function() { // render fonts bar
            NumbersPanel.renderFontAccents(function() { // render font accents
                NumbersPanel.renderFontColors(function() { // render font colors
                    // enable location buttons
                    $('.richardson-numbers-container .location-buttons button').prop("disabled", false);

                    var enabledBtnEl = $('#richardson-numbers-locations .location-buttons button.btn-enabled');
                    if (enabledBtnEl.length !== 0) {
                        $(_this).prop("disabled", true).addClass("uk-active");
                    }

                    $('#richardson-numbers-font-bar').fadeIn();
                    $('#richardson-numbers-font-accents').fadeIn();
                    $('#richardson-numbers-font-colors').fadeIn();

                    // Disable Functionality
                    if (RichardsonOrderEditor.isCompleted()) {
                        NumbersPanel.disableModifier();
                    }
                });
            });
        });
    },

    onPreviousFont: function() {
        var app_code = $(this).data("app-code").toString();
        ApplicationCore.controllers.changeTextApplicationFontStyle(app_code, NumbersPanel.PREVIOUS_FONT);
    },

    onNextFont: function() {
        var app_code = $(this).data("app-code").toString();
        ApplicationCore.controllers.changeTextApplicationFontStyle(app_code, NumbersPanel.NEXT_FONT);
    },

    onOpenFontsModal: function() {
        var app_code = $(this).data('app-code').toString();
        var application = ub.funcs.getApplicationSettings(app_code);

        if (typeof application !== "undefined") {
            var sample_text = $('#richardson-numbers-input-number').val();

            if (_.isEmpty(sample_text)) {
                sample_text = "Sample Text";
            }
            
            ApplicationCore.utilities.openFontModal(sample_text, application);
        } else {
            ub.utilities.info("Error: Application code " + app_code + " is invalid code.");
        }
    },

    onChangeFontAccent: function() {
        var app_code = $(this).data("app-code").toString();
        var accent_id = $(this).data("accent-id");
        var application = ub.funcs.getApplicationSettings(app_code);

        // Change Font Accent
        ApplicationCore.controllers.changeTextApplicationAccent(accent_id, application);

        // Update font colors
        NumbersPanel.numbersPanel.setFontColors(application);

        $('#richardson-numbers-font-colors').hide();
        NumbersPanel.renderFontColors(function() {
            $('#richardson-numbers-font-colors').fadeIn();
        });

        $('#richardson-numbers-font-accents .change-font-accent').removeClass("uk-active");
        $(this).addClass("uk-active");
    },

    onChangeFontColor: function() {
        var app_code = $(this).data("app-code").toString();
        var layer_number = $(this).data("layer-number");
        var color_code = $(this).data("color-code");
        var application = ub.funcs.getApplicationSettings(app_code);
        var colorObj = ub.funcs.getColorByColorCode(color_code);

        if (application !== undefined) {
            var layer_name = $(this).data("layer-name");
            var layer = _.find(application.accent_obj.layers, {name: layer_name});

            if (layer !== undefined) {
                ApplicationCore.controllers.changeTextApplicationColor(application, layer_name, layer_number, colorObj);
            } else {
                ub.utilities.info("Error: Layer name " + layer_name + " is invalid.");
            }
        } else {
            ub.utilities.info("Error: Application code " + app_code + " is invalid.");
        }

        $('#richardson-numbers-font-colors .font-colors .change-font-color[data-layer-number="'+ layer_number +'"]').find(".checkContainer").html("");
        
        if (colorObj.color_code === 'W' || 
            colorObj.color_code === 'Y' ||
            colorObj.color_code === 'CR' ||
            colorObj.color_code === 'S' ||
            colorObj.color_code === 'PK' ||
            colorObj.color_code === 'OP' ||
            colorObj.color_code === 'SG'
        ) {
            $(this).find(".checkContainer").html($('#richardson-numbers-font-colors-active-state-tmpl').html());
        } else {
            $(this).find(".checkContainer").html($('#richardson-numbers-font-colors-active-state-tmpl-white').html());
        }
    }
};

NumbersPanel.renderLocations = function() {
    var locations = NumbersPanel.numbersPanel.getLocations();

    var items = {
        locationsFlag: locations.length > 0,
        locations: locations
    };

    var tmpl = Mustache.render($('#richardson-numbers-locations-tmpl').html(), items);
    $('#richardson-numbers-locations').html(tmpl);

    // Disable Functionality
    if (RichardsonOrderEditor.isCompleted()) {
        var parent = $(".richardson-numbers-container");
        // Disable Location Button
        $(".location-buttons button:not(.btn-enabled)", parent).addClass("uk-disabled");
        $("#richardson-numbers-input-number", parent).addClass("uk-disabled");
    }
};

NumbersPanel.renderFontsBar = function(app_code, callback) {
    $('#richardson-numbers-font-bar').hide();
    $('#richardson-numbers-font-accents').hide();
    $('#richardson-numbers-font-colors').hide();

    var application = _.find(ub.current_material.settings.applications, {code: app_code});

    if (application !== undefined) {
        var items = {
            previous_font: NumbersPanel.PREVIOUS_FONT,
            next_font: NumbersPanel.NEXT_FONT,
            app_code: app_code,
            font_family: application.font_obj.name,
            font_text: application.font_obj.caption
        };

        var tmpl = Mustache.render($('#richardson-numbers-font-bar-tmpl').html(), items);
        $('#richardson-numbers-font-bar').html(tmpl);

        _.delay(callback, 100);
    } else {
        ub.utilities.info("Error: Application Code " + app_code + " is invalid.");
    }
};

NumbersPanel.renderFontAccents = function(callback) {
    var fontAccents = NumbersPanel.numbersPanel.getFontAccents();

    var items = {
        fontAccentsFlag: fontAccents.length > 0,
        fontAccents: fontAccents
    };

    var fontAccentsTmpl = Mustache.render($('#richardson-numbers-font-accents-tmpl').html(), items);
    $('#richardson-numbers-font-accents').html(fontAccentsTmpl);

    _.delay(callback, 100);
};

NumbersPanel.renderFontColors = function(callback) {
    var fontColors = NumbersPanel.numbersPanel.getFontColors();

    var tmpl = _.template($("#player-number-colors-template").html());
    $('#richardson-numbers-font-colors').html("");
    $('#richardson-numbers-font-colors').html(tmpl({
        colors: fontColors
    }));

    _.delay(callback, 100);
};

NumbersPanel.changeFontStyle = function(app_code, direction, font_id) {
    var application = _.find(ub.current_material.settings.applications, {code: app_code});

    if (application !== undefined) {
        var newFont;

        if (direction !== false) {
            newFont = ub.funcs.getFontObj(direction, application.font_obj, application.application_type);
        } else {
            newFont = _.find(ub.data.fonts, {id: font_id.toFixed()});
        }

        if (typeof newFont !== 'undefined') {
            font_id = newFont.id;

            ub.funcs.changeFontFromPopup(font_id, application);
            var font_style_el = $("#richardson-numbers-font-bar .open-fonts-modal");

            $(font_style_el).text(newFont.caption);
            $(font_style_el).css('font-family', newFont.name);
        } else {
            // No Font!
            return;
        }

        if (application.type === NumbersPanel.LOCATION_FRONT.type || application.type === NumbersPanel.LOCATION_BACK.type) {
            _.each(ub.current_material.settings.applications, function (application) {
                if (application.type !== application.application_type && application.type !== NumbersPanel.LOGO_TYPE && application.type !== NumbersPanel.MASCOT_TYPE) {
                    if (application.type.indexOf('number') !== -1 && application.type.indexOf('number') !== -1) {
                        ub.funcs.changeFontFromPopup(font_id, application);
                    }
                }
            });
        }

        var matchingID = ub.data.matchingIDs.getMatchingID(app_code.toString());

        if (typeof matchingID !== "undefined") {
            var matchingSettingsObject = _.find(ub.current_material.settings.applications, {code: matchingID.toString()});
            ub.funcs.changeFontFromPopup(font_id, matchingSettingsObject);
        }
    } else {
        ub.utilities.info("Error: Application code " + app_code + " is invalid.");
    }
};

NumbersPanel.showHideRemoveButton = function() {
    var enabledBtnEl = $('#richardson-numbers-locations .location-buttons button.btn-enabled');

    $(enabledBtnEl).first().click();
    $(enabledBtnEl).first().prop('disabled', true);

    // hide remove button if number of enabled is only 1
    if (enabledBtnEl.length === 1) {
        var removeBtnEl = enabledBtnEl.next();
        removeBtnEl.addClass("invisible");
    }

    // show remove button if number of enabled is above 1
    if (enabledBtnEl.length > 0) {
        $(enabledBtnEl).each(function(index, el) {
            if ($(el).next().hasClass("invisible")) {
                $(el).next().removeClass("invisible");
            }
        });
    } else {
        ub.modifierController.numbers();
    }
};

NumbersPanel.changeNumber = function(number) {
    var filteredApps = _.filter(ub.current_material.settings.applications, function(app) {
        if (app.application_type === NumbersPanel.LOCATION_LEFT_SLEEVE.type) {
            return _.contains([NumbersPanel.LOCATION_LEFT_SLEEVE.layer, NumbersPanel.LOCATION_RIGHT_SLEEVE.layer], app.application.layer);
        }

        return _.contains([NumbersPanel.LOCATION_FRONT.type, NumbersPanel.LOCATION_BACK.type], app.application_type);
    });

    _.each(filteredApps, function(app) {
        if (app.text !== number.toString()) {
            app.text = number.toString();
            ub.funcs.changeFontFromPopup(app.font_obj.id, app);
        }
    });
};

NumbersPanel.setNumberToDefault = function() {
    var location_el = $('#richardson-numbers-locations .location-buttons button.uk-active');

    if (location_el.length !== 0) {
        var app_code = location_el.data("app-code").toString();
        var application = _.find(ub.current_material.settings.applications, {code: app_code});

        $('#richardson-numbers-input-number').val(application.text);
    }
};

NumbersPanel.getAllTextApplication = function() {
    var textApplications = _.filter(ub.current_material.settings.applications, function(text) {
        if (_.contains(["sleeve_number", "front_number", "back_number", "shoulder_number"], text.application_type)) {
            return text;
        }
    });

    if (_.size(textApplications) === 0) {
        textApplications = _.filter(ub.current_material.settings.applications, function(text) {
            if (_.contains(["team_name", "player_name"], text.application_type)) {
                return text;
            }
        });
    }

    return textApplications;
}

NumbersPanel.disableModifier = function() {
    var parent = $(".richardson-numbers-container");
    // Disable Input text
    $("#richardson-numbers-input-number", parent).addClass("uk-disabled");
    // Disable Font
    $("#richardson-numbers-font-bar", parent).addClass("uk-disabled");
    // Disable Accent
    $("#richardson-numbers-font-accents", parent).addClass("uk-disabled");
    // Disable Colors
    $("#richardson-numbers-font-colors .font-colors", parent).addClass("uk-disabled");
    // Remove Location Disable
    $(".remove-location", parent).addClass("uk-disabled")
}